import React from 'react';
import {ActivityIndicator} from 'react-native';
import {useTheme} from 'styled-components/native';
import {OverlayModal} from '../../OverlayModal';
import {Backdrop, Card, Description, SpinnerWrapper, Title} from './styles';

interface CheckoutGetnetLoadingProps {
  visible: boolean;
  title?: string;
  description?: string;
}

export function CheckoutGetnetLoading({
  visible,
  title = 'Processando seu pagamento',
  description = 'Aguarde alguns instantes enquanto confirmamos sua compra com o banco. Isso pode levar alguns minutos — não feche o aplicativo.',
}: CheckoutGetnetLoadingProps) {
  const theme = useTheme();

  return (
    <OverlayModal
      isVisible={visible}
      hasBackdrop={false}
      animationIn="fadeIn"
      animationOut="fadeOut"
      style={{margin: 0}}>
      <Backdrop>
        <Card>
          <SpinnerWrapper>
            <ActivityIndicator color={theme.colors.background} size="small" />
          </SpinnerWrapper>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Card>
      </Backdrop>
    </OverlayModal>
  );
}
